(function () {
  const KACHING_BLOCK_SELECTOR = 'kaching-bundles-block, kaching-bundle, .kaching-bundles';
  const KACHING_SELECTED_PRICE_SELECTOR =
    '.kaching-bundles__bar--selected .kaching-bundles__bar-price, .kaching-bundles__bar--selected [class*="price"]';
  const watchedDrawers = new WeakSet();

  function getPriceScope(el) {
    return el?.closest?.('quick-buy-drawer') ?? el?.closest?.('.shopify-section') ?? document;
  }

  function reviveScripts(root) {
    Array.from(root.querySelectorAll('script:not([data-revived])')).forEach((oldScript) => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
      newScript.dataset.revived = 'true';
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }

  function reinitKaching(attempts) {
    if (typeof window.kachingBundlesInitialize === 'function') {
      window.kachingBundlesInitialize();
      return;
    }
    if (attempts > 0) {
      setTimeout(() => reinitKaching(attempts - 1), 200);
    }
  }

  function priceFromEvent(detail) {
    if (!detail) return null;
    if (typeof detail.formattedPrice === 'string' && detail.formattedPrice) return detail.formattedPrice;
    if (typeof detail.formatted_price === 'string' && detail.formatted_price) return detail.formatted_price;
    if (typeof detail.price === 'string' && detail.price) return detail.price;
    return null;
  }

  function priceFromDom(scope) {
    const priceEl = scope.querySelector(KACHING_SELECTED_PRICE_SELECTOR);
    const text = priceEl?.textContent?.trim();
    return text || null;
  }

  function setSalePrice(el, priceText) {
    const last = el.lastChild;
    if (last && last.nodeType === Node.TEXT_NODE) {
      last.textContent = priceText;
      return;
    }
    el.append(document.createTextNode(priceText));
  }

  function syncKachingPrice(scope, event) {
    const priceText = priceFromEvent(event?.detail) || priceFromDom(scope);
    if (!priceText) return;

    scope.querySelectorAll('sale-price').forEach((el) => setSalePrice(el, priceText));
  }

  function handleContentInjected(drawer) {
    reviveScripts(drawer);
    reinitKaching(10);
    requestAnimationFrame(() => syncKachingPrice(drawer));
  }

  function watchDrawer(drawer) {
    if (!(drawer instanceof Element) || watchedDrawers.has(drawer)) return;
    watchedDrawers.add(drawer);

    const observer = new MutationObserver(() => handleContentInjected(drawer));
    observer.observe(drawer, { childList: true });
  }

  function watchNewDrawers() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches?.('quick-buy-drawer')) watchDrawer(node);
          node.querySelectorAll?.('quick-buy-drawer').forEach(watchDrawer);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function initStickyQuickAdd() {
    document.querySelectorAll('product-quick-add').forEach((bar) => {
      bar.addEventListener(
        'click',
        (event) => {
          const submit = event.target.closest('button[type="submit"]');
          if (!submit) return;

          const formId = bar.getAttribute('form') || submit.getAttribute('form');
          const form = formId ? document.getElementById(formId) : null;
          const scope = getPriceScope(form || bar);
          const kachingBlock = scope.querySelector(KACHING_BLOCK_SELECTOR);
          if (!kachingBlock) return;

          event.preventDefault();
          event.stopPropagation();
          kachingBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },
        true
      );
    });
  }

  function initPriceSync() {
    const onKachingEvent = (event) => {
      const scope = getPriceScope(event.target);
      syncKachingPrice(scope, event);
    };

    document.addEventListener('deal-bar-selected', onKachingEvent, true);
    document.addEventListener('variants-changed', onKachingEvent, true);
  }

  function init() {
    document.querySelectorAll('quick-buy-drawer').forEach(watchDrawer);
    watchNewDrawers();
    initStickyQuickAdd();
    initPriceSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
